/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3NodeProvidersNodeProviderIdRequest = {
  /**
   * Node Provider ID
   */
  nodeProviderId: string;
};

/** @internal */
export const GetApiV3NodeProvidersNodeProviderIdRequest$inboundSchema:
  z.ZodType<GetApiV3NodeProvidersNodeProviderIdRequest, z.ZodTypeDef, unknown> =
    z.object({
      node_provider_id: z.string(),
    }).transform((v) => {
      return remap$(v, {
        "node_provider_id": "nodeProviderId",
      });
    });

/** @internal */
export type GetApiV3NodeProvidersNodeProviderIdRequest$Outbound = {
  node_provider_id: string;
};

/** @internal */
export const GetApiV3NodeProvidersNodeProviderIdRequest$outboundSchema:
  z.ZodType<
    GetApiV3NodeProvidersNodeProviderIdRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3NodeProvidersNodeProviderIdRequest
  > = z.object({
    nodeProviderId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      nodeProviderId: "node_provider_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NodeProvidersNodeProviderIdRequest$ {
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3NodeProvidersNodeProviderIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3NodeProvidersNodeProviderIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3NodeProvidersNodeProviderIdRequest$Outbound;
}

export function getApiV3NodeProvidersNodeProviderIdRequestToJSON(
  getApiV3NodeProvidersNodeProviderIdRequest:
    GetApiV3NodeProvidersNodeProviderIdRequest,
): string {
  return JSON.stringify(
    GetApiV3NodeProvidersNodeProviderIdRequest$outboundSchema.parse(
      getApiV3NodeProvidersNodeProviderIdRequest,
    ),
  );
}

export function getApiV3NodeProvidersNodeProviderIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3NodeProvidersNodeProviderIdRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3NodeProvidersNodeProviderIdRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3NodeProvidersNodeProviderIdRequest' from JSON`,
  );
}
